import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get } from 'lodash';
import { PROCEDURE_STATUSES } from 'containers/data-structure';
import messages from 'containers/common/LegalProceedings/JudgementAdd/Recap/Pronouncing/messages';
import { translate } from 'containers/services/translate';
import { showJADDDecision } from 'containers/common/LegalProceedings/JudgementAdd/Recap/Pronouncing/utils';
import { JudgementADDDocumentType } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { Container } from 'containers/common/LegalProceedings/JudgementAdd/Recap/styled-component';
import { IJudgementAdd } from 'containers/LawyerLegalProceedingsPage/typings';

export interface JudgementAddDecisionRecapProps {
  intl: IntlShape;
  judgementAddDocument: JudgementADDDocumentType;
  judgementAdd?: IJudgementAdd | {};
}

const JudgementAddDecisionRecap: React.FC<JudgementAddDecisionRecapProps> = (
  props,
): JSX.Element => {
  const STATUS = {
    TO_EDIT: translate(messages.rejectedDecision, props),
    VALIDATED: translate(messages.validatedDecision, props),
    MODIFIED: translate(messages.validatedDecision, props),
  } as any;
  return (
    <Container>
      {showJADDDecision(props.judgementAdd, props.judgementAddDocument) && (
        <section className="jadd-decision-recap-container">
          <div className="jadd-decision-recap">
            <h4 className="decision-recap-container-title">
              {translate(messages.courtManagerJudgementAddDecision, props)}
            </h4>
            &nbsp;
            <h4 className="decision-recap-container-status">
              <span>{STATUS[get(props, 'judgementAdd.status', '')]}</span>
            </h4>
          </div>
          {get(props, 'judgementAdd.status') === PROCEDURE_STATUSES.TO_EDIT && (
            <div className="jadd-decision-recap">
              <article className="decision-status">
                <span className="decision-sub-bloc-title">
                  {translate(messages.rejectionReason, props)}
                </span>
                <span>{get(props, 'judgementAdd.rejectionReason', '')}</span>
              </article>
            </div>
          )}
        </section>
      )}
    </Container>
  );
};

export default injectIntl(JudgementAddDecisionRecap);
